export type BacklogCategory =
  | "contracts_sales"
  | "finance_investments"
  | "people"
  | "processes_operations"
  | "legal_contract_risks"
  | "ideas";

export type BacklogStatus = "open" | "in_progress" | "done" | "closed";

export type BacklogVoteValue = "plus" | "minus" | "neutral" | "later";

export interface BacklogVote {
  user_id: string;
  user_name: string;
  value: BacklogVoteValue;
  updated_at: string;
}

export interface BacklogComment {
  id: string;
  author_id: string | null;
  author_name: string;
  content: string;
  created_at: string;
}

export interface BacklogEntry {
  id: string;
  title: string;
  description: string;
  category: BacklogCategory;
  is_urgent: boolean;
  discussion_date: string | null;
  status: BacklogStatus;
  author: string;
  author_name: string;
  owner: string | null;
  owner_name: string;
  decision: string;
  decided_by_name: string;
  decided_at: string | null;
  votes: BacklogVote[];
  comment_count: number;
  created_at: string;
  updated_at: string;
}

export interface BacklogMember {
  id: string;
  name: string;
}

export interface BacklogEntryFormData {
  title: string;
  description: string;
  category: BacklogCategory;
  is_urgent: boolean;
  discussion_date: string | null;
}

export const BACKLOG_CATEGORIES: { value: BacklogCategory; label: string }[] = [
  { value: "contracts_sales", label: "Kontrakty i sprzedaż" },
  { value: "finance_investments", label: "Finanse i inwestycje" },
  { value: "people", label: "Ludzie" },
  { value: "processes_operations", label: "Procesy i operacje" },
  { value: "legal_contract_risks", label: "Ryzyka prawne i kontraktowe" },
  { value: "ideas", label: "Pomysły na później" },
];

export const CATEGORY_LABELS: Record<BacklogCategory, string> = Object.fromEntries(
  BACKLOG_CATEGORIES.map((c) => [c.value, c.label]),
) as Record<BacklogCategory, string>;

export const STATUS_LABELS: Record<BacklogStatus, string> = {
  open: "Otwarty",
  in_progress: "W realizacji",
  done: "Zrealizowany",
  closed: "Zamknięty",
};

export const VOTE_LABELS: Record<BacklogVoteValue, string> = {
  plus: "Za",
  minus: "Przeciw",
  neutral: "Neutralny",
  later: "Na kiedyś",
};

/** All cast votes say "later" — the topic drops off the meeting agenda. */
export function allVotesLater(entry: BacklogEntry): boolean {
  return entry.votes.length > 0 && entry.votes.every((v) => v.value === "later");
}
